module.exports = __webpack_public_path__ + "static/img/operateHuhui.3823a2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateHuhui.png
// module id = kySJ
// module chunks = 1